export default __webpack_public_path__ + "static/101-d2287d2851101613178e05888b3d1116.jpg";